import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 登录回调地址
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/components/callback.vue'),
  },

  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
  },
  {
    path: '*',
    redirect: {
      name: 'home' // 默认页面
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.afterEach(to => {
  const prefix = '一键退出'
  document.title = to.meta && to.meta.title
    ? `${prefix}-${to.meta.title}` : prefix
})

export default router
